export default "__VITE_ASSET__B3q4MncK__"